import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import titleMixin from "./mixins/titleMixin";
import "bootstrap";

import VueScrollTo from "vue-scrollto";
import VueGoogleMap from "vuejs-google-maps";
import VueScrollactive from "vue-scrollactive";

Vue.mixin(titleMixin);

Vue.use(VueScrollactive);
Vue.use(VueGoogleMap, {
  load: {
    apiKey: "AIzaSyDnM_ZyTXKKvXQwEHex5etmK1zk89vgwa0"
    // libraries: ['...']
  }
});

Vue.use(VueScrollTo, {
  container: "body",
  duration: 800,
  easing: "ease-in-out",
  offset: -60,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
